export const LOCALE_NAMES = {
  en: "English",
  ru: "Русский",
  es: "Español"
} as const

export type AdminLocale = keyof typeof LOCALE_NAMES
export const ADMIN_LOCALES = Object.keys(LOCALE_NAMES) as AdminLocale[]
export const DEFAULT_ADMIN_LOCALE: AdminLocale = "en"

// The agent build adds Arabic; the operator panel keeps its three languages.
export const APP_LOCALE_NAMES: Record<string, string> =
  process.env.REACT_APP_SURFACE === "agent" ? { ...LOCALE_NAMES, ar: "العربية" } : LOCALE_NAMES
export const APP_LOCALES = Object.keys(APP_LOCALE_NAMES)
export const RTL_LOCALES = ["ar"]
